module.exports = __webpack_public_path__ + "pic/1.14d8d7e1.png";